import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { Title } from './parts';

import { JSX } from 'react';
import styles from './privacyTableTitle.module.scss';

export type PrivacyTableTitleProps =
  SliceComponentProps<Content.PrivacyTableTitleSlice>;

const PrivacyTableTitle = ({ slice }: PrivacyTableTitleProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      id={slice.id}
      className={styles.section}
    >
      <Title title={slice.primary.title} />
    </section>
  );
};

export default PrivacyTableTitle;
